/**
 * Delete all layers belonging to a specific source. This is called when a source is removed from the map, to ensure that all dependent layers are removed before the source is removed, to avoid an error.
 * @param map
 * @param sourceId
 * @returns
 */
export const removeLayersBySource = (map, sourceId) => {
  if (!map) return

  const layers = map.getStyle()?.layers
  if (!layers) return

  for (const layer of layers) {
    if (layer.source === sourceId) {
      map.removeLayer(layer.id)
    }
  }
}
